import type { GlobePoint } from "#shared/schemas/globe.ts";

function hashJitter(id: string): { dLat: number; dLng: number } {
  let h = 2166136261;
  for (let i = 0; i < id.length; i++) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const a = ((h >>> 0) % 1000) / 1000;
  const b = ((h >>> 10) % 1000) / 1000;
  return { dLat: (a - 0.5) * 4.5, dLng: (b - 0.5) * 4.5 };
}

/** Build jittered artist points for ?dev=points stress test. */
export function buildDevArtistPoints(
  points: GlobePoint[],
  n: number,
): GlobePoint[] {
  const artists: Array<{
    id: string;
    code: string;
    label: string;
    lat: number;
    lng: number;
  }> = [];
  for (const p of points) {
    if (!p.countryCode) continue;
    for (const artistId of p.artistIds) {
      artists.push({
        id: artistId,
        code: p.countryCode,
        label: p.label,
        lat: p.lat,
        lng: p.lng,
      });
    }
  }
  artists.sort((a, b) => a.id.localeCompare(b.id));
  const take = artists.slice(0, Math.min(n, artists.length));
  return take.map((a) => {
    const j = hashJitter(a.id);
    return {
      id: `artist:${a.id}`,
      kind: "country" as const,
      lat: a.lat + j.dLat,
      lng: a.lng + j.dLng,
      label: a.label,
      artistCount: 1,
      artistIds: [a.id],
      countryCode: a.code,
    };
  });
}
